var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z",
    fill: "#1572B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z",
    fill: "#33A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z",
    fill: "#EBEBEB"
  }));
};